import { PHYSICS, GAME } from '../constants/index.js';
import { ArenaState, OrbState, PlayerState } from '../types/index.js';

let orbIdCounter = 0;

export class OrbManager {
  private orbs: OrbState[] = [];
  private arena: ArenaState;
  private respawnTimer: number = GAME.ORB_RESPAWN_TICKS;

  constructor(arena: ArenaState) {
    this.arena = arena;
  }

  spawnInitialOrbs(): void {
    for (let i = 0; i < GAME.ORBS_INITIAL_COUNT; i++) {
      this.spawnOrb();
    }
  }

  update(tick: number, players: Map<string, PlayerState>): void {
    this.respawnTimer++;
    this.removeOutsideArena();

    const activeCount = this.orbs.filter((o) => !o.collected).length;
    if (this.respawnTimer >= GAME.ORB_RESPAWN_TICKS && activeCount < GAME.ORBS_MAX_COUNT) {
      this.spawnOrb();
      this.respawnTimer = 0;
    }

    this.checkCollection(players);
    this.removeCollected();
  }

  private spawnOrb(): void {
    const angle = Math.random() * Math.PI * 2;
    const safeRadius = Math.max(0, this.arena.radius - PHYSICS.ORB_RADIUS);
    const radius = Math.sqrt(Math.random()) * safeRadius;

    const orb: OrbState = {
      id: orbIdCounter++,
      x: Math.cos(angle) * radius,
      y: Math.sin(angle) * radius,
      radius: PHYSICS.ORB_RADIUS,
      collected: false,
      spawnTick: 0,
      value: GAME.ORB_VALUE,
    };

    this.orbs.push(orb);
  }

  private checkCollection(players: Map<string, PlayerState>): void {
    for (const player of players.values()) {
      if (!player.alive) continue;

      for (const orb of this.orbs) {
        if (orb.collected) continue;

        const dx = player.x - orb.x;
        const dy = player.y - orb.y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < PHYSICS.ORB_COLLECT_RADIUS) {
          orb.collected = true;
          player.orbs += orb.value;
        }
      }
    }
  }

  private removeCollected(): void {
    this.orbs = this.orbs.filter((o) => !o.collected);
  }

  private removeOutsideArena(): void {
    const safeRadius = Math.max(0, this.arena.radius - PHYSICS.ORB_RADIUS);
    const safeRadiusSquared = safeRadius * safeRadius;
    this.orbs = this.orbs.filter((orb) => {
      const dx = orb.x - this.arena.centerX;
      const dy = orb.y - this.arena.centerY;
      return dx * dx + dy * dy <= safeRadiusSquared;
    });
  }

  getOrbs(): OrbState[] {
    return this.orbs.filter((o) => !o.collected);
  }
}